export function getProjects(){
	return projects;
}

const projects = [
	{ id:"Support", value:"Support" },
	{ id:"Failure Testing", value:"Failure Testing" },
	{ id:"Quality Management", value:"Quality Management" },
	{ id:"Data Quality", value:"Data Quality" }
];
